export default __webpack_public_path__ + "static/media/Create-documentation.547ab659.md";